
export const BASE_URL = window.location.host.replace('dashboard', 'admin').replace('3000', '8000')
